import { useTranslation } from '@crehana/i18n';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';

import { getBaseUrl } from '@/shared/utils';

export type AuthSEOProps = {
  title?: string;
  description?: string;
};

export const AuthSEO: React.FC<React.PropsWithChildren<AuthSEOProps>> = ({
  title,
  description,
}) => {
  const { t } = useTranslation();
  const router = useRouter();
  const baseURL = getBaseUrl();

  return (
    <NextSeo
      titleTemplate="%s | Crehana"
      title={title || t('SEO_TITLE')}
      description={description || t('SEO_DESCRIPTION')}
      canonical={`${baseURL}${router.asPath.split('?')[0]}`}
      openGraph={{
        type: 'website',
        site_name: 'Crehana',
        images: [
          {
            url: 'https://static.crehana.com/static/img/logo/logo-crehana.6a48047513e0.png',
            alt: 'Crehana',
          },
        ],
      }}
    />
  );
};

export default AuthSEO;
